<template>
  <div :class="$style.exchange">
    <div :class="$style.heading_box">
      <h4>マイルを交換する</h4>
      <p
        >お買い物やアクションによって貯まったマイルは、クーポンをはじめとする様々な特典に交換することができます。マイルの交換期限は、獲得した日から12か月後の末日となります。</p
      >
    </div>
    <GuideExchangeList />
    <AtomsConsumerButton block variant="secondary" @click="() => router.push('/mypage')"
      >保有マイルを確認する</AtomsConsumerButton
    >
  </div>
</template>

<script lang="ts" setup>
const router = useRouter()
</script>
<style scoped module lang="scss">
.exchange {
  padding: 0 1rem 44px 1rem;
  border-bottom: 1px solid $primary-20;
  margin-bottom: 44px;

  h4 {
    @include main-font;
    margin-bottom: 18px;
    font-size: $font-size-20;
    color: $primary;
  }

  .heading_box {
    margin-bottom: 18px;
  }
}
</style>
